var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"build"},[(_vm.getCurrentSidebarElement==='Home')?_c('Home'):_vm._e(),(_vm.getCurrentSidebarElement==='ItWomen')?_c('Itwomen'):_vm._e(),(_vm.getCurrentSidebarElement==='About')?_c('About'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }